import { LAYOUT_TABS } from '@silverfort-nodelibs/common/utils/consts';
import { usePricingModulesState } from '../../../context/contexts/PricingModuleContext';
import { Pages, Roles } from '../../../context/contexts/UserContext/permissionsTypes';
import useHasPermissions from '../../../hooks/useHasPermissions';
import { LogicalRoute, LogicalRouteImportProps } from '../../../routings/helpers/LogicalRoute';
import CloudNHI from '../CloudNHI';
import { CloudNHIBlockPage } from '../CloudNHIBlockPage/CloudNHIBlockPage';

export const CloudNHIRouting = (props: LogicalRouteImportProps) => {
    const { isPageBlocked } = usePricingModulesState();
    const displayBlockPage = isPageBlocked(LAYOUT_TABS.SERVICE_ACCOUNTS_CLOUD.ID);
    const hasPermissions = useHasPermissions({ permission: Pages.SERVICE_ACCOUNTS, role: Roles.VIEWER });

    return (
        <LogicalRoute
            {...props}
            component={CloudNHI}
            blockPageComponent={CloudNHIBlockPage}
            displayBlockPage={displayBlockPage}
            disabled={!hasPermissions}
        />
    );
};
